import { render, staticRenderFns } from "./doctorDetail.vue?vue&type=template&id=461d84e0&scoped=true"
import script from "./doctorDetail.vue?vue&type=script&lang=js"
export * from "./doctorDetail.vue?vue&type=script&lang=js"
import style0 from "./doctorDetail.vue?vue&type=style&index=0&id=461d84e0&prod&lang=less&scoped=true"
import style1 from "./doctorDetail.vue?vue&type=style&index=1&id=461d84e0&prod&scoped=true&lang=css"
import style2 from "./doctorDetail.vue?vue&type=style&index=2&id=461d84e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461d84e0",
  null
  
)

export default component.exports